import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_de8058xhwh: FaireBrandEntity = {
  token: "b_de8058xhwh",
  type: "brand",
  name: "TBCo",
  avatarUrl:
    "https://cdn.faire.com/fastly/2eec77f1e62e6c57fb3920d51789b5be8729e9416bce20e9a164c083df0cd008.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0b06d051f0b82c5c3a64f44ff3006015767659b756827bb0a9f669c23e9d0c9c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2eec77f1e62e6c57fb3920d51789b5be8729e9416bce20e9a164c083df0cd008.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0b06d051f0b82c5c3a64f44ff3006015767659b756827bb0a9f669c23e9d0c9c.png",
  location: "Edinburgh, Scotland, GBR",
  minimumOrderDollars: 500,
  rating: 4.9,
  reviewCount: 139,
  isTopShop: true,
  isInsider: false,
  description:
    "Elevate your every day with TBCo, a B Corp-certified brand on a mission to create design-leading accessories that add the finishing touch to your outfit and home. Founded in 2014 by Emma Macdonald, TBCo focuses on using natural and recycled fibres to create statement pieces that inspire style confidence and positively impact the planet.\n\nChoosing to shop with a B Corporation certified brand means that you can rest assured knowing that we are actively delivering on our pledge to be a positive impact company and a force for good in the world.\n\nDiscover our range of homewares and style accessories designed in Scotland.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.023Z",
    importedBy: "entity-db-cli",
  },
};
